import { loadAccessToken, setAccessToken } from "@/utils/storage";
import authService from "@/api/services/authService";
import { useUserStore } from "@/store/user";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default [
  async ({ to }: MiddlewareInterface) => {
    if (!loadAccessToken() || !to.matched.some((record) => record.meta.requiresAuth)) {
      return;
    }

    const restrictedHosts = import.meta.env.VITE_RESTRICTED_MEMBERAREA_HOSTS.split(",");
    const host = window.location.host.split(".").slice(-2).join(".");

    if (restrictedHosts.includes(host)) {
      await new Promise(() => {
        window.location.href = `${import.meta.env.VITE_MEMBERAREA_HOST + to.fullPath}?authToken=${loadAccessToken()}`;
      });
    }
  },
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    if (to.query.hash) {
      try {
        const access_token = await authService.login_by_hash(to.query.hash as string);
        setAccessToken(access_token);
        await useUserStore(pinia).fetchProfile();
      } catch {
        // ignore authentication error
      }

      delete to.query.hash;
      await redirect(to);
    }
  },
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    if (to.query.authToken) {
      try {
        setAccessToken(to.query.authToken as string);
        delete to.query.authToken;
        await useUserStore(pinia).fetchProfile();
        await redirect(to.path === "/" ? useUserStore(pinia).getLandingUrl : to);
      } catch {
        // ignore authentication error
      }
    }
  },
  async ({ pinia }: MiddlewareInterface) => {
    const userStore = useUserStore(pinia);

    if (!userStore.getProfile && loadAccessToken()) {
      await userStore.fetchProfile();
    }
  },
  async ({ to, pinia }: MiddlewareInterface) => {
    const userStore = useUserStore(pinia);
    const user = userStore.getProfile;
    const unauthorized = !user || !loadAccessToken();

    if (to.matched.some((record) => record.meta.requiresAuth) && unauthorized) {
      await userStore.logout({
        path: "/#log_in",
        query: { redirect: to.fullPath },
      });
      return false;
    }
  },
];
